import React from 'react';
import { BaseDefinitionsPopup } from './BaseDefinitionsPopup';
import { voiceDefinitions } from 'src/components/BeaconV2Components/ExperimentalLayout/ContentV3/components/VoiceAndTone/VoiceAndTonePagePopup';

export const VoiceDefinitionsPopup = ({ open, onClose }: { open: boolean; onClose: () => void }) => {
  return (
    <BaseDefinitionsPopup open={open} onClose={onClose} title="Voice Definitions" definitions={voiceDefinitions} />
  );
};
